/**
 * Version tabs - switch between simulator iterations
 */
export default function VersionTabs({ activeVersion, onVersionChange }) {
  const versions = [
    {
      id: 'v0.1',
      label: 'v0.1',
      name: 'Technical',
      description: '6-entity particle physics',
      status: 'archived'
    },
    {
      id: 'v0.2',
      label: 'v0.2',
      name: 'Consumer',
      description: 'Edutainment focused',
      status: 'archived'
    },
    {
      id: 'v0.3',
      label: 'v0.3',
      name: 'Strategy',
      description: 'Interactive game',
      status: 'active'
    }
  ];

  return (
    <div className="flex items-center gap-2 mb-6 pb-4 border-b border-[#333]">
      <div className="text-sm text-[#888] mr-2">Iterations:</div>
      {versions.map(version => {
        const isActive = activeVersion === version.id;
        const isArchived = version.status === 'archived';
        
        return (
          <button
            key={version.id}
            onClick={() => onVersionChange(version.id)}
            className={`
              px-4 py-2.5 rounded-lg border-2 transition-all
              ${isActive 
                ? 'border-[#667eea] bg-[#667eea]/10 text-white' 
                : 'border-[#333] bg-[#1a1a1a] text-[#888] hover:border-[#555] hover:text-[#ccc]'
              }
              ${isArchived ? 'opacity-70' : ''}
            `}
          >
            <div className="flex items-center gap-2">
              <span className="font-mono font-bold text-sm">{version.label}</span>
              <div className="text-left">
                <div className="text-xs font-semibold leading-tight">{version.name}</div>
                <div className="text-[10px] leading-tight opacity-70">{version.description}</div>
              </div>
              {isArchived && (
                <span className="text-[10px] bg-[#333] px-1.5 py-0.5 rounded uppercase">Archived</span>
              )}
              {isActive && (
                <span className="text-[10px] bg-[#667eea] px-1.5 py-0.5 rounded uppercase">Active</span>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
}

